import * as constants from './constants';

const initialState = {
  subObservations: [],
  allSubObservations: [],
  subUpdateLoading: false,
  subIsAdding: false,
};

const observationSubObservationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_SUB_OBSERVATION:
      return {
        ...state,
        subUpdateLoading: true,
      };
    case constants.CREATE_SUB_OBSERVATION_SUCCESS:
      let subObservations =
        action.data?.data?.learning_activity_sub_observations || [];
      let updatedObservations = subObservations
        .map((sub) => {
          return {
            _id: sub._id,
            position: sub.position,
            learning_activity_id: action.data?.data?.learning_activity,
            observation_id: action.data?.data?.observation,
            sub_observation_id: sub.sub_observation._id,
            name: sub.sub_observation.name,
            icon: sub.sub_observation.icon,
            deleted_status: sub.sub_observation.deleted_status,
            detail: sub.sub_observation?.detail,
          };
        })
        .sort((a, b) => a.position - b.position);

      return {
        ...state,
        subUpdateLoading: false,
        subObservations: updatedObservations,
        subIsAdding: false,
      };
    case constants.CREATE_SUB_OBSERVATION_ERROR:
      return {
        ...state,
        subUpdateLoading: false,
        // subIsAdding: false,
        // subObservations: [],
      };

    case constants.UPDATE_SUB_OBSERVATION_ORDER:
      return {
        ...state,
        subUpdateLoading: true,
      };
    case constants.UPDATE_SUB_OBSERVATION_ORDER_SUCCESS:
      let subObservationsData =
        action.data?.data?.learning_activity_sub_observations || [];
      let updatedSubObsOrder = subObservationsData
        .map((sub) => {
          return {
            _id: sub._id,
            position: sub.position,
            learning_activity_id: action.data?.data?.learning_activity,
            observation_id: action.data?.data?.observation,
            sub_observation_id: sub.sub_observation._id,
            name: sub.sub_observation.name,
            icon: sub.sub_observation.icon,
            deleted_status: sub.sub_observation.deleted_status,
            detail: sub.sub_observation?.detail,
          };
        })
        .sort((a, b) => a.position - b.position);

      return {
        ...state,
        subUpdateLoading: false,
        subObservations: updatedSubObsOrder,
      };
    case constants.UPDATE_SUB_OBSERVATION_ORDER_ERROR:
      return {
        ...state,
        subUpdateLoading: false,
      };

    case constants.FETCH_SUB_OBSERVATION:
      return {
        ...state,
        subUpdateLoading: true,
      };
    case constants.FETCH_SUB_OBSERVATION_SUCCESS:
      // let subObsData = action.data || [];
      // let updatedSubObservation = subObsData
      //   .map((sub) => {
      //     return {
      //       _id: sub._id,
      //       position: sub.position,
      //       learning_activity_id: action.data?.learning_activity_id,
      //       observation_id: action.data?.observation_id._id,
      //       sub_observation_id: sub.observation_id._id,
      //       name: sub.observation_id.name,
      //       icon: sub.observation_id.icon,
      //       deleted_status: sub.observation_id.deleted_status,
      //       detail: sub.observation_id?.detail,
      //     };
      //   })
      //   .sort((a, b) => a.position - b.position);
      return {
        ...state,
        subUpdateLoading: false,
        subObservations: action.data,
        subIsAdding: false,
      };
    case constants.FETCH_SUB_OBSERVATION_ERROR:
      return {
        ...state,
        subUpdateLoading: false,
        subIsAdding: false,
      };

    case constants.UPDATE_SUB_OBSERVATION:
      return {
        ...state,
        subUpdateLoading: true,
      };
    case constants.UPDATE_SUB_OBSERVATION_SUCCESS:
      let subObs = action.data?.data?.learning_activity_sub_observations || [];
      let updatedSubObs = subObs
        .map((sub) => {
          return {
            _id: sub._id,
            position: sub.position,
            learning_activity_id: action.data?.data?.learning_activity,
            observation_id: action.data?.data?.observation,
            sub_observation_id: sub.sub_observation._id,
            name: sub.sub_observation.name,
            icon: sub.sub_observation.icon,
            deleted_status: sub.sub_observation.deleted_status,
            detail: sub.sub_observation?.detail,
          };
        })
        .sort((a, b) => a.position - b.position);

      return {
        ...state,
        subObservations: updatedSubObs,
        subUpdateLoading: false,
        subIsAdding: false,
      };
    case constants.UPDATE_SUB_OBSERVATION_ERROR:
      return {
        ...state,
        subUpdateLoading: false,
        // subIsAdding: false,
      };
    case constants.IS_SUB_OBSERVATION_ADD_UPDATE:
      return {
        ...state,
        subIsAdding: action.data,
      };

    case constants.FETCH_ALL_SUB_OBSERVATION_REQUEST:
      return {
        ...state,
        fetchingLoading: true,
        error: null,
      };

    case constants.FETCH_ALL_SUB_OBSERVATION_SUCCESS:
      return {
        ...state,
        allSubObservations: action.data,
        fetchingLoading: false,
        error: null,
      };

    case constants.FETCH_ALL_SUB_OBSERVATION_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        error: action.error || 'Something went wrong!',
      };

    case constants.UPDATE_ALL_SUB_OBSERVATIONS:
      return { ...state, updateLoading: true, error: null };

    case constants.UPDATE_ALL_SUB_OBSERVATIONS_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allSubObservations: state.allSubObservations.map((subObservation) =>
          action.payload.some((updated) => updated._id === subObservation._id)
            ? action.payload.find(
                (updated) => updated._id === subObservation._id
              )
            : subObservation
        ),
      };

    case constants.SORT_SUB_OBSERVATIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case constants.SORT_SUB_OBSERVATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        allSubObservations: action.payload.data || state.allSubObservations,
      };

    case constants.SORT_SUB_OBSERVATIONS_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default observationSubObservationsReducer;
